import React from "react";
import ReactDOM from "react-dom/client";
import { AlugarVsFinanciar } from "./calculators/alugar-vs-financiar";
import CalculadoraDeRenda from "./calculators/calculadora-de-renda";
import ComparadorRendaFixa from "./calculators/comparador-de-renda-fixa";
import JurosCompostos from "./calculators/juros-compostos";
import { JurosSimples } from "./calculators/juros-simples";
import { ReservaEmergencia } from "./calculators/reserva-emergencia";
import { SimuladorAposentadoria } from "./calculators/simulador-aposentadoria";
import SavingsSelicSimulator from "./calculators/simulador-poupanca-selic";
import "./styles/globals.css";
import CalculadoraPJ from "./calculators/calculadora-pj";
import CalculadoraComparativa from "./calculators/calculadora-comparativa";
import SalarioLiquido from "./calculators/salario-liquido";
import PrimeiroMilhao from "./calculators/primeiro-milhao";
import DecimoTercerio from "./calculators/decimo-terceiro";
import SalarioFerias from "./calculators/salario-ferias";
import SalarioFeriasProporcional from "./calculators/ferias-proporcional";
import CalculadoraINSS from "./calculators/calculadora-inss";
import CalculadoraFGTS from "./calculators/calculadora-fgts";
import HorasExtras from "./calculators/horas-extras";
import CalculadoraJurosRotativo from "./calculators/calculadora-rotativo";
import CalculadoraCustoFuncionarioCLT from "./calculators/custo-funcionario";
import SeguroDesemprego from "./calculators/calculadora-seguro-desemprego";
import ContadorDias from "./calculators/contador-dias";
import VistaPrazo from "./calculators/vista-prazo";
import RealidadeBrasileira from "./calculators/salario-realidade-brasileira";
import IsencaoIR from "./calculators/calculadora-isencao-ir";
import RescisaoTrabalhista from "./calculators/rescisao-trabalhista";
import ContadorDiasUteis from "./calculators/contador-dias-uteis";
import VeiculoEletrico from "./calculators/calculadora-veiculo-eletrico";
import CustosFixos from "./calculators/calculadora-custos-fixos";
import CalculadoraPixParcelado from "./calculators/pix-parcelado";
import JurosCompostosNoIndex from "./calculators/juros-compostos-noindex";
import RealidadeBrasileiraNoIndex from "./calculators/salario-realidade-brasileira-noindex";
import CalculadoraCDB from "./calculators/calculadora-cdb";
import MarcaçãoMercado from "./calculators/marcacao-mercado";
import CalculadoraAmortizacao from "./calculators/calculadora-amortizacao";
declare global {
  interface pulseTracker {
    trackEvent: (
      eventName: string,
      eventData: string,
      customerEmail: string,
    ) => void;
  }

  interface Window {
    WP_Data: {
      is_user_logged_in: boolean;
      user_id: number;
      user_name: string;
      user_email: string;
      email_verified: boolean;
      ajax_url: string;
    };
    pulseTracker: pulseTracker;
  }
}

const calculatorComponents = {
  "compound-interest": JurosCompostos,
  "compare-fixed-income": ComparadorRendaFixa,
  "simulador-poupanca-selic": SavingsSelicSimulator,
  "juros-simples": JurosSimples,
  "reserva-emergencia": ReservaEmergencia,
  "simulador-aposentadoria": SimuladorAposentadoria,
  "alugar-vs-financiar": AlugarVsFinanciar,
  "calculadora-de-renda": CalculadoraDeRenda,
  "salario-liquido": SalarioLiquido,
  "calculadora-pj": CalculadoraPJ,
  "calculadora-comparativa": CalculadoraComparativa,
  "primeiro-milhao": PrimeiroMilhao,
  "calculadora-juros-rotativo": CalculadoraJurosRotativo,
  "decimo-terceiro": DecimoTercerio,
  "calculadora-custo-funcionario": CalculadoraCustoFuncionarioCLT,
  "salario-ferias": SalarioFerias,
  "ferias-proporcional": SalarioFeriasProporcional,
  "calculadora-inss": CalculadoraINSS,
  "calculadora-fgts": CalculadoraFGTS,
  "horas-extras": HorasExtras,
  "calculadora-seguro-desemprego": SeguroDesemprego,
  "realidade-brasileira": RealidadeBrasileira,
  "contador-dias": ContadorDias,
  "vista-prazo": VistaPrazo,
  "calculadora-isencao-ir": IsencaoIR,
  "rescisao-trabalhista": RescisaoTrabalhista,
  "contador-dias-uteis": ContadorDiasUteis,
  "comparador-veiculo": VeiculoEletrico,
  "custos-fixos": CustosFixos,
  "pix-parcelado": CalculadoraPixParcelado,
  "juros-compostos-mkt": JurosCompostosNoIndex,
  "realidade-brasileira-mkt": RealidadeBrasileiraNoIndex,
  "calculadora-cdb": CalculadoraCDB,
  "marcacao-mercado": MarcaçãoMercado,
  "calculadora-amortizacao": CalculadoraAmortizacao,
} as const;

Object.keys(calculatorComponents).forEach((id) => {
  const element = document.getElementById(id);

  if (element) {
    const root = ReactDOM.createRoot(element as HTMLElement);
    const Component =
      calculatorComponents[id as keyof typeof calculatorComponents];

    /*  root.render(
      <React.StrictMode>
        <JurosSimples />
      </React.StrictMode>
    );

    return; */
    root.render(
      <React.StrictMode>
        <Component />
      </React.StrictMode>,
    );
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
